import React, { useState } from "react";
import { Row, Col, Card, CardBody, Button, Spinner } from "reactstrap";
import BarChart from "./BarChart";
import BarChartCity from "./BarChartCIty";
import BarChartDistrict from "./BarChartDistricts";

const TopTen = ({ topten , loading}) => {
  const [selectedChart, setSelectedChart] = useState("crops");

  const handleButtonClick = (chartType) => {
    setSelectedChart(chartType);
  };

  return (
    <Row>
      <Col sm={12}>
        <Card style={{ borderRadius: "20px"}}>
        <CardBody>
            <div style={{ padding: "10px" }}>
              <Button
                className="mr-3 mb-2 mb-sm-0"
                style={{ borderRadius: "7px", height: "40px", minWidth: "120px" }}
                outline
                onClick={() => handleButtonClick("crops")}
              >
                Top 10 Crops
              </Button>
              <Button
                className="mr-3 mb-2 mb-sm-0"
                style={{ borderRadius: "7px", height: "40px", minWidth: "120px" }}
                outline
                onClick={() => handleButtonClick("cities")}
              >
                Top 10 Cities
              </Button>
              <Button
                className="mr-3 mb-2 mb-sm-0"
                style={{ borderRadius: "7px", height: "40px", minWidth: "120px" }}
                outline
                onClick={() => handleButtonClick("districts")}
              >
                Top 10 Districts
              </Button>
            </div>
            {loading ? (
              <div className="text-center" style={{ marginTop: "40px" }}>
                <Spinner className="mr-2" color="success" />
              </div>
            ) : (
              <>
                {selectedChart === "crops" && <BarChart topten={topten}/>}
                {selectedChart === "cities" && <BarChartCity topten={topten}/>}
                {selectedChart === "districts" && (
                  <BarChartDistrict topten={topten} />
                )}
              </>
            )}
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default TopTen;
